import { render, staticRenderFns } from "./AmountKpisDashboard.vue?vue&type=template&id=428410b6&scoped=true&"
import script from "./AmountKpisDashboard.vue?vue&type=script&lang=js&"
export * from "./AmountKpisDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AmountKpisDashboard.vue?vue&type=style&index=0&id=428410b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428410b6",
  null
  
)

export default component.exports